export default "__VITE_ASSET__DI89d5KE__"